import { get } from 'lodash';
import _ from 'lodash';
import { createSelector } from 'reselect';

import { getEntityByName } from '../appEntities';
import {
    ACCEPT_NEXIO_AGREEMENT_LOAD,
    ACCEPT_NEXIO_AGREEMENT_SUCCESS,
    ACCEPT_NEXIO_AGREEMENT_FAILURE,
    ACCEPT_NEXIO_PRICING_AGREEMENT_LOAD,
    ACCEPT_NEXIO_PRICING_AGREEMENT_SUCCESS,
    ACCEPT_NEXIO_PRICING_AGREEMENT_FAILURE,
    ACCEPT_NEXIO_SURCHARGE_AGREEMENT_LOAD,
    ACCEPT_NEXIO_SURCHARGE_AGREEMENT_FAILURE,
    ACCEPT_NEXIO_SURCHARGE_AGREEMENT_SUCCESS,
    MERCHANT_LEGAL_INFORMATION_LOAD,
    MERCHANT_LEGAL_INFORMATION_FAILURE,
    MERCHANT_LEGAL_INFORMATION_SUCCESS
} from './accountAgreementActions';

export default function reducer(state = { isNexioAgreementAccepted: false, isPricingAgreementAccepted: false, isSurchargeAgreementAccepted: false }, action = {}) {
    let newState;

    switch (action.type) {
        case ACCEPT_NEXIO_AGREEMENT_LOAD:
            newState = {
                ...state,
                isNexioAgreementAccepted: false,
                error: null,
                isNexioAgreementAcceptLoading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_AGREEMENT_SUCCESS:
            newState = {
                ...state,
                isNexioAgreementAccepted: true,
                error: null,
                isNexioAgreementAcceptLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_AGREEMENT_FAILURE:
            newState = {
                ...state,
                error: action.error,
                isNexioAgreementAcceptLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_PRICING_AGREEMENT_LOAD:
            newState = {
                ...state,
                isPricingAgreementAccepted: false,
                error: null,
                isPricingAgreementAcceptLoading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_PRICING_AGREEMENT_SUCCESS:
            newState = {
                ...state,
                isPricingAgreementAccepted: true,
                isPricingAgreementAcceptLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_PRICING_AGREEMENT_FAILURE:
            newState = {
                ...state,
                error: action.error,
                isPricingAgreementAccepted: false,
                isPricingAgreementAcceptLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_SURCHARGE_AGREEMENT_LOAD:
            newState = {
                ...state,
                isSurchargeAgreementAccepted: false,
                error: null,
                isSurchargeAgreementAcceptLoading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_SURCHARGE_AGREEMENT_SUCCESS:
            newState = {
                ...state,
                isSurchargeAgreementAccepted: true,
                isSurchargeAgreementAcceptLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case ACCEPT_NEXIO_SURCHARGE_AGREEMENT_FAILURE:
            newState = {
                ...state,
                error: action.error,
                isSurchargeAgreementAccepted: false,
                isSurchargeAgreementAcceptLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case MERCHANT_LEGAL_INFORMATION_LOAD:
            newState = {
                ...state,
                error: null,
                isMerchantLegalInformationLoading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case MERCHANT_LEGAL_INFORMATION_SUCCESS:
            newState = {
                ...state,
                isMerchantLegalInformationLoading: false,
                merchantLegalInformation: action.merchantLegalInformation
            };

            return _.isEqual(state, newState) ? state : newState;

        case MERCHANT_LEGAL_INFORMATION_FAILURE:
            newState = {
                ...state,
                error: action.error,
                isMerchantLegalInformationLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getNexioAgreementEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'accountAgreement')
);

export const getIsNexioAgreementAccepted = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'isNexioAgreementAccepted')
);

export const getIsPricingAgreementAccepted = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'isPricingAgreementAccepted')
);

export const getIsSurchargeAgreementAccepted = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'isSurchargeAgreementAccepted')
);

export const getNexioAgreementError = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'error')
);

export const getNexioPricingError = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'error')
);

export const getSurchargeAgreementError = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'error')
);

export const getIsNexioAgreementAcceptLoading = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'isNexioAgreementAcceptLoading')
);

export const getIsPricingAgreementAcceptLoading = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'isPricingAgreementAcceptLoading')
);

export const getIsSurchargeAgreementAcceptLoading = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'getIsSurchargeAgreementAcceptLoading')
);

export const getMerchantLegalInformation = createSelector(
    getNexioAgreementEntity,
    (entity) => get(entity, 'merchantLegalInformation')
);
